import { RoleEnum } from '../../models/Index';

function isAccessGranted(context, currentRoles: string[]): boolean {
    const permittedRoles = getPermittedRoles(context);
    const intersection = permittedRoles?.filter((value) => currentRoles.includes(value));
    return intersection?.length > 0 ? true : false;
}

function getPermittedRoles(route: string): string[] {
    return {
        additionalLinks: [RoleEnum.VIEWER, RoleEnum.DESIGNER],
        addStageButton: [RoleEnum.DESIGNER, RoleEnum.ADMIN, RoleEnum.SUPER_USER],
        addWidgetButton: [RoleEnum.DESIGNER, RoleEnum.ADMIN, RoleEnum.SUPER_USER],
        buttonMenu: [RoleEnum.DESIGNER, RoleEnum.ADMIN, RoleEnum.SUPER_USER],
        customerSettings: [RoleEnum.ADMIN, RoleEnum.SUPER_USER],
        stageEditing: [RoleEnum.DESIGNER, RoleEnum.ADMIN, RoleEnum.SUPER_USER],
        stageGrouping: [RoleEnum.ADMIN, RoleEnum.SUPER_USER],
        widgetEditing: [RoleEnum.DESIGNER, RoleEnum.ADMIN, RoleEnum.SUPER_USER],
    }[route];
}

const DoormanService = {
    isAccessGranted,
};

export default DoormanService;
